import { View } from 'backbone.marionette';
import template from './index.jst';
import { Model } from 'backbone';
import './index.styl';
import Radio from "backbone.radio";
import { isMobile } from "../../../../../core/utils";

const MATCH_CENTRE_CHANNEL = Radio.channel('match_centre');

export class MatchCentreHeading extends View {
	get template() {
		return template;
	}

	get className() {
		return 'match-centre-table-heading';
	}

	ui() {
		return {
			order_by: '.js-order-by'
		}
	}

	events() {
		return {
			'click @ui.order_by': 'changeOrder'
		}
	}

	initialize() {
		this.is_asc_order = false;
		this.active_sorting = false;
		this.order_by = 'stats.points_last_round';
		this.model = new Model({
			headings: [],
			is_asc_order: this.is_asc_order,
			order_by: this.order_by,
			is_mobile: isMobile(),
			mobile_column: 'stats.points_last_round',
			selected_match: {}
		});


	}

	init({ headings, selected_match }) {

		if (selected_match.status === 'scheduled' && !this.active_sorting) {
			this.order_by = 'stats.avg_points';
		}
		else {
			this.order_by = 'stats.points_last_round';
		}

		this.model.set({
			headings,
			selected_match,
			order_by: this.order_by,
			mobile_column: this.order_by,
		});

		this.render();
	}

	changeOrder(event) {
		this.active_sorting = true;

		const $element = $(event.currentTarget),
			order_by = $element.data('order-by');

		if (order_by === this.order_by) {
			this.is_asc_order = !this.is_asc_order;
		}
		else {
			this.order_by = order_by;
			this.is_asc_order = false;
		}

		const order_params = {
			is_asc_order: this.is_asc_order,
			order_by: this.order_by
		};

		this.model.set(order_params);

		MATCH_CENTRE_CHANNEL.trigger('sorting', order_params);
		this.render();

	}
}

export default MatchCentreHeading;